import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { VIDEO_ON_DEMAND } from '../../../../api/stream/CustomStreamEvent';
import AbstractTable from '../../../common/AbstractTable';
import ListActionItems from '../../../List/ListActionItems';
import StreamStatus from './StreamStatus';
import { FormattedDate, FormattedTime } from 'react-intl';

import { TableRow, TableRowColumn, TableHeaderColumn } from 'material-ui/Table';

class StreamList extends AbstractTable {
  static propTypes = {
    ...AbstractTable.propTypes,
    onChangeFilter: PropTypes.func,
    displayStatus: PropTypes.bool
  };

  defaultProps = {
    displayStatus: false
  };

  headerTitle = 'Streams';
  confirmRemoveMessage = (
    <FormattedMessage
      id="record.remove"
      defaultMessage="Are you sure you want to delete stream video?"
    />
  );

  _renderHeader() {
    const { tableHeaderStyle, fixedHeaderStyle } = this.getStyles();
    let { displayStatus, filter } = this.props;
    return (
      <TableRow>
        <TableHeaderColumn style={tableHeaderStyle}>Name</TableHeaderColumn>
        {displayStatus ? (
          <TableHeaderColumn style={fixedHeaderStyle}>Status</TableHeaderColumn>
        ) : null}
        {filter.streamType !== VIDEO_ON_DEMAND ? (
          <TableHeaderColumn style={tableHeaderStyle}>
            Start Time
          </TableHeaderColumn>
        ) : null}
        <TableHeaderColumn style={fixedHeaderStyle}>Actions</TableHeaderColumn>
      </TableRow>
    );
  }

  _renderContentItem(item, key) {
    let { title, status, startDate, full_name } = item;
    let { displayStatus } = this.props;
    const { tableColumnStyle, fixedColumnStyle } = this.getStyles();

    return (
      <TableRow key={key}>
        <TableRowColumn style={tableColumnStyle}>
          {title || full_name}
        </TableRowColumn>
        {displayStatus ? (
          <TableRowColumn style={fixedColumnStyle}>
            <StreamStatus status={status} />
          </TableRowColumn>
        ) : null}
        <TableRowColumn style={tableColumnStyle}>
          {this._renderFullTime(startDate)}
        </TableRowColumn>
        <TableRowColumn style={fixedColumnStyle}>
          <ListActionItems
            edit={this.props.edit}
            remove={this.props.delete}
            record={item}
            confirmMessageLabel={this.confirmRemoveMessage}
          />
        </TableRowColumn>
      </TableRow>
    );
  }

  _renderFullTime(date) {
    return date ? (
      <span>
        <FormattedDate value={date} />{' '}
        <FormattedTime value={date} format="short" />
      </span>
    ) : (
      <span>-</span>
    );
  }
}

export default StreamList;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamUpcomming/StreamUpcomming.jsx